import { z } from "zod";

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 Mo
const ALLOWED_MIME_TYPES = [
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/webp",
  "application/pdf",
  "text/plain",
  "text/csv",
];

// ── Route entry (structured, one per affected route) ──
export const routeEntrySchema = z.object({
  route: z.string().optional().nullable(),
  routeTitle: z.string().optional().nullable(),
  apiEndpoint: z.string().optional().nullable(),
  errorMessage: z.string().optional().nullable(),
});

// ── Flat ticket schema (single-page form) ──
export const ticketSchema = z.object({
  title: z
    .string()
    .min(1, "Le titre est requis")
    .max(255, "Le titre ne doit pas dépasser 255 caractères"),
  description: z
    .string()
    .min(10, "La description doit contenir au moins 10 caractères")
    .max(5000, "La description ne doit pas dépasser 5000 caractères"),
  category: z.enum(
    [
      "bug_bloquant",
      "bug_mineur",
      "interface_mouche",
      "fonctionnalite_manquante",
      "lenteur",
      "ergonomie",
      "documentation",
      "securite",
    ],
    { message: "La catégorie est requise" },
  ),
  routeEntries: z.array(routeEntrySchema).optional().nullable(),
  attachments: z
    .array(
      z
        .instanceof(File)
        .refine((file) => file.size <= MAX_FILE_SIZE, {
          message: "Chaque fichier ne doit pas dépasser 10 Mo",
        })
        .refine((file) => ALLOWED_MIME_TYPES.includes(file.type), {
          message: "Type de fichier non autorisé",
        }),
    )
    .optional()
    .nullable(),
});

export type RouteEntryFormData = z.infer<typeof routeEntrySchema>;
export type TicketFormData = z.infer<typeof ticketSchema>;

export const TICKET_ACCEPT_MIME = ALLOWED_MIME_TYPES.join(",");
export const TICKET_MAX_FILE_SIZE = MAX_FILE_SIZE;
